const contractorRouter = [
  {
      path: "list-contractor",
      name: "contractor",
      component: () => import("@/views/admin/contractor"),
      default: true,
      meta: {
          model: "contractor",
          // requiresAuth: true,
      },
  },
  {
      path: "list-contractor/add",
      name: "addContractor",
      component: () => import("@/views/admin/contractor/function"),
      default: true,
      meta: {
          model: "contractor",
          // requiresAuth: true,
      },
  },
  {
      path: "list-contractor/edit/:id",
      name: "editContractor",
      component: () => import("@/views/admin/contractor/function"),
      default: true,
      meta: {
          model: "contractor",
          // requiresAuth: true,
      },
  },
  {
      path: "list-contractor/view/:id",
      name: "viewContractor",
      component: () => import("@/views/admin/contractor/view"),
      default: true,
      meta: {
          model: "contractor",
          // requiresAuth: true,
      },
  }
]
export default contractorRouter;